import { render, staticRenderFns } from "./ShowAllVehicles.vue?vue&type=template&id=64a2bc04&scoped=true"
import script from "./ShowAllVehicles.vue?vue&type=script&lang=js"
export * from "./ShowAllVehicles.vue?vue&type=script&lang=js"
import style0 from "./ShowAllVehicles.vue?vue&type=style&index=0&id=64a2bc04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a2bc04",
  null
  
)

export default component.exports